export enum TaskListSectionType {
  DUE_TODAY = "dueToday",
  DUE_END_OF_WEEK = "dueEndOfWeek",
  OTHER = "other",
}
